<div
    *ngIf="(tableBase.dataSource.latestData | async)?.data?.length > 0"
    class="filter-actions"
    fxLayout="row"
    fxLayoutAlign="start center"
>
    <button
        matTooltip="Send message"
        i18n-matTooltip
        mat-icon-button
        (click)="$event.stopPropagation(); onMessageSelected()"
    >
        <mat-icon>speaker_notes</mat-icon>
    </button>
    <button
        (click)="$event.stopPropagation(); onEmailSelected()"
        mat-icon-button
        matTooltip="Send email"
        i18n-matTooltip
    >
        <mat-icon>email</mat-icon>
    </button>
</div>
<app-user-table-base
    #tableBase
    matSortActive="signedoff_at"
    [columnsData]="columnsData"
    [columnsKeys]="columnsKeys"
    [expandedRowId]="expandedRowId"
    [expandedFn]="expandedFn"
    (expansionToggled)="expansionToggled($event)"
    (onRowClick)="browse($event)"
    [otherContext]="otherContext"
    [expandingTable]="false"
    [canSelect]="false"
    [filtersExpanded]="true"
    [filter]="filter"
    [tableFilterItems]="tableFilterItems"
>
    <ng-container tableFiltersTempl>
        <app-table-filter
            [filtersTogglesInOnBtn]="true"
            [defaultFilter]="GlobalFilterProperty.SEARCH"
            [inGlobalFilter]="true"
            color="accent"
            #filter
        >
            <app-table-search
                toggleBtnLabel="Schema"
                i18n-toggleBtnLabel
                [inGlobalFilter]="true"
                class="align-space"
                searchFilterRef
            ></app-table-search>

            <app-select-filter
                [inGlobalFilter]="true"
                class="filter-space"
                label="Approval"
                i18n-label
                [property]="GlobalFilterProperty.REVIEW_STATUS"
                [options]="approvalStatusOptions"
                resApprovalStatusRef
            ></app-select-filter>
        </app-table-filter>
    </ng-container>
</app-user-table-base>

<ng-template #img let-user>
    <app-image-view
        [ngStyle]="{ minWidth: '50px' }"
        [isCircularImg]="true"
        [ignoreThumbnail]="true"
        [media_id]="user.media"
        paddingBottom="50px"
    ></app-image-view>
</ng-template>
<ng-template #name let-user>
    <ng-container *ngIf="!(isMobile$ | async)">
        <span
            [ngStyle]="{
                color:
                    user.signoff?.approval_status === 'approved'
                        ? '#bfd8d0'
                        : user.signoff?.approval_status === 'rejected'
                        ? '#a7a7a7'
                        : '#ff9961'
            }"
        >
            {{ user.name }}</span
        >
    </ng-container>
    <ng-container *ngIf="isMobile$ | async">
        <div fxLayout="row" fxLayoutGap="5px" class="w-100" fxLayoutAlign="start start">
            <app-image-view
                [ngStyle]="{ minWidth: '50px' }"
                [isCircularImg]="true"
                [ignoreThumbnail]="true"
                [media_id]="user.media"
                paddingBottom="50px"
            ></app-image-view>
            <span class="res-title" fxFlex="grow"> {{ user.name }}</span>
            <div fxLayout="column" fxLayoutAlign="start start">
                <button
                    *ngIf="user.id as expandId"
                    class="mob-expand-btn"
                    (click)="$event.stopPropagation(); expansionToggled(user)"
                    mat-icon-button
                >
                    <mat-icon>{{ expandedFn(user) ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #registred_date let-user>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@signoffDate">Signoff date</span>
    <div>{{ user.signoff?.signedoff_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</div>
</ng-template>

<ng-template #registration_status let-user>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@signoffStatus">Signoff Status</span>
    <div
        [matTooltip]="user.signoff?.signedoff_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        *ngIf="user.signoff?.approval_status === 'approved'"
        (click)="$event.stopPropagation()"
    >
        <div
            fxLayout="row"
            class="status-text approved-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'approved')"
        >
            <mat-icon>task_alt</mat-icon>
            <span i18n="@@approved">Approved</span>
        </div>
        <mat-icon class="approved-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <div
        [matTooltip]="user.signoff?.signedoff_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.signoff?.approval_status === 'rejected'"
    >
        <div
            fxLayout="row"
            class="status-text rejected-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'rejected')"
        >
            <mat-icon>cancel</mat-icon>
            <span i18n="@@rejected">Rejected</span>
        </div>
        <mat-icon class="rejected-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <div
        fxLayout="row"
        class="status-text pending-status"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.signoff?.approval_status == 'pending'"
    >
        <div
            fxLayout="row"
            class="status-text pending-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'pending')"
        >
            <mat-icon>pending_actions</mat-icon>
            <span i18n="@@pending">Pending</span>
        </div>
        <mat-icon class="pending-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <div
        fxLayout="row"
        class="status-text pending-status"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.signoff?.approval_status == 'waiting'"
    >
        <div
            fxLayout="row"
            class="status-text pending-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'waiting')"
        >
            <mat-icon>pending</mat-icon>
            <span i18n="@@waitinglist">Waiting list</span>
        </div>
        <mat-icon class="pending-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <mat-menu #pendingMenu="matMenu">
        <button
            [disabled]="user.signoff?.approval_status === 'approved'"
            mat-menu-item
            class="approved-status"
            (click)="$event.stopPropagation(); updateAppprovmentOnTheFly(user, 'approved')"
        >
            <mat-icon>check_circle</mat-icon>
            <span i18n="@@approve">Approve</span>
        </button>
        <button
            [disabled]="user.signoff?.approval_status === 'rejected'"
            mat-menu-item
            class="rejected-status"
            (click)="$event.stopPropagation(); updateAppprovmentOnTheFly(user, 'rejected')"
        >
            <mat-icon>cancel</mat-icon>
            <span i18n="@@reject">Reject</span>
        </button>
        <button
            [disabled]="user.signoff?.approval_status === 'waiting'"
            mat-menu-item
            class="pending-status"
            (click)="$event.stopPropagation(); updateAppprovmentOnTheFly(user, 'waiting')"
        >
            <mat-icon>pending</mat-icon>
            <span i18n="@@waitinglist">Waiting list</span>
        </button>
    </mat-menu>
</ng-template>

<ng-template #tools let-user>
    <div *ngIf="!(isMobile$ | async)" class="tools-cell-wrapper">
        <button
            (click)="$event.stopPropagation(); onSelectStats(user)"
            matTooltip="Statistics"
            mat-icon-button
            class="action"
            i18n-matTooltip="@@staticstics"
        >
            <mat-icon>insights</mat-icon>
        </button>
        <button
            (click)="$event.stopPropagation(); sendEmail(user)"
            mat-icon-button
            [matTooltip]="authUser?.getActivationMailInfo(user)?.tooltip"
            [ngClass]="authUser?.getActivationMailInfo(user)?.class"
        >
            <mat-icon>email</mat-icon>
        </button>
        <button
            matTooltip="Send message"
            i18n-matTooltip
            mat-icon-button
            (click)="$event.stopPropagation(); sendMsg(user)"
        >
            <mat-icon>speaker_notes</mat-icon>
        </button>
        <button
            (click)="$event.stopPropagation(); browse(user)"
            matTooltip="Edit"
            class="action"
            mat-icon-button
            i18n-matTooltip="@@edit"
        >
            <mat-icon>edit</mat-icon>
        </button>
    </div>
    <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="isMobile$ | async">
        <button
            class="hover-tools-btn view"
            mat-icon-button
            matTooltip="View"
            (click)="$event.stopPropagation(); browse(user)"
            i18n-matTooltip="@@view"
        >
            <mat-icon>visibility</mat-icon>
        </button>

        <button *ngIf="!!user.user_collaboration?.edit?.status" (click)="$event.stopPropagation()" mat-icon-button>
            <mat-icon>edit</mat-icon>
        </button>
        <button (click)="$event.stopPropagation(); expansionToggled(user)" class="expand-btn" mat-icon-button>
            <mat-icon>{{ expandedFn(user) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
